import React from 'react';
import PropTypes from 'prop-types';
import Container from './container';
import Render from './render';
import Loader from './components/loader';

const Search = ({
  query,
  options,
  showAllResults,
  keyboardNavigation,
  onSelect,
  styling,
  onItemClick,
  onRawClick,
  onEnter,
  onExit,
  onSearchResultFound,
  disableScrollToTop,
  inputMinLength,
  showStoreLogo,
}) => {
  if (query.length < inputMinLength) {
    return null;
  }

  const queryOptions = options;
  return (
    <Container
      query={query}
      queryOptions={queryOptions}
      disableScrollToTop={disableScrollToTop}
      onSearchResultFound={onSearchResultFound}
      renderLoader={() => <Loader isActive />}
      render={results => {
        return (
          <Render
            showAllResults={showAllResults}
            keyboardNavigation={keyboardNavigation}
            results={results}
            query={query}
            onSelect={onSelect}
            styling={styling}
            onItemClick={onItemClick}
            onRawClick={onRawClick}
            onEnterSearchMenu={onEnter}
            onExitSearchMenu={onExit}
            showStoreLogo={showStoreLogo}
          />
        );
      }}
    />
  );
};

Search.propTypes = {
  query: PropTypes.string,
  showAllResults: PropTypes.bool,
  keyboardNavigation: PropTypes.bool,
  options: PropTypes.object,
  onSelect: PropTypes.func,
  onRawClick: PropTypes.func,
  onItemClick: PropTypes.func,
  styling: PropTypes.string,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  onSearchResultFound: PropTypes.func,
  disableScrollToTop: PropTypes.bool,
  inputMinLength: PropTypes.number,
  showStoreLogo: PropTypes.bool,
};

Search.defaultProps = {
  query: '',
  keyboardNavigation: true,
  showAllResults: true,
  options: {
    groups: [
      {
        limit: 3,
        name: 'categories',
        modes: [
          {
            name: 'brand_category',
            params: {
              fq: 'row_type:category OR row_type:brand_category OR row_type:virtual_category OR row_type:brand_virtual_category',
            },
          },
        ],
      },
      {
        limit: 10,
        name: 'products',
        modes: ['product', 'raw_sorted', 'raw'],
      },
    ],
  },
  onSelect: undefined,
  styling: undefined,
  onRawClick: () => {},
  onItemClick: () => {},
  onEnter: () => {},
  onExit: () => {},
  onSearchResultFound: () => {},
  disableScrollToTop: false,
  inputMinLength: 2,
  showStoreLogo: false,
};

export default Search;
